module.exports = __webpack_public_path__ + "static/media/bnr7.3e3485ac.jpg";